import React from 'react';
import PageHeader from 'components/common/general/layouts/PageHeader';

const FavoriteProposalsHeader = (): JSX.Element => {
  return (
    <PageHeader
      title="Favorite Proposals"
      subtitle="Here you have the ability to manage proposal templates"
      spacing="WITH_ACTION_BELOW"
      showBackButton={false}
    />
  );
};

export default FavoriteProposalsHeader;
